import React from "react";
import "./Loading.css";

const Loading = () => (
  <section className="tpc-loading-overlay" aria-label="Loading">
    <div className="tpc-loading-wrapper">
      <div className="tpc-loading-spinner" />
      {/* <p className="tpc-loading-text">
        <span className="dots"></span>
      </p> */}
    </div>
  </section>
);

export default Loading;
